import React from 'react';
import PaymentForm from './PaymentForm';
import { useNavigate } from 'react-router-dom';

interface ConsultationPaymentProps {
  requestId: string;
  doctorName?: string;
  consultationDate?: string;
}

const ConsultationPayment: React.FC<ConsultationPaymentProps> = ({
  requestId,
  doctorName,
  consultationDate
}) => {
  const navigate = useNavigate();

  const handlePaymentSuccess = () => {
    // Redirect to success page
    navigate(`/payment-success?requestId=${requestId}`);
  };

  const handleCancel = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen gradient-pastel py-12 px-4">
      <div className="container mx-auto max-w-4xl">
        {/* Consultation Summary */}
        <div className="card mb-8">
          <h2 className="text-xl font-bold text-luma-text mb-4">Consultation Summary</h2>
          <div className="space-y-3">
            {doctorName && (
              <div className="flex justify-between">
                <span className="text-luma-text-light">Healthcare Professional:</span>
                <span className="font-medium text-luma-text">{doctorName}</span>
              </div>
            )}
            {consultationDate && (
              <div className="flex justify-between">
                <span className="text-luma-text-light">Consultation Date:</span>
                <span className="font-medium text-luma-text">{consultationDate}</span>
              </div>
            )}
            <div className="flex justify-between">
              <span className="text-luma-text-light">Request ID:</span>
              <span className="font-mono text-sm text-luma-text">{requestId}</span>
            </div>
            <div className="flex justify-between pt-3 border-t border-luma-border">
              <span className="text-lg font-semibold text-luma-text">Total Amount:</span>
              <span className="text-2xl font-bold text-luma-primary">$19.99</span>
            </div>
          </div>
        </div>

        {/* Payment Form */}
        <PaymentForm
          requestId={requestId}
          onSuccess={handlePaymentSuccess}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default ConsultationPayment;
